let state = { templates: {}, settings: ["fantasy"] };
export const setTemplates = (u) => { state = { templates: u?.templates || {}, settings: u?.world_settings || ["fantasy"] }; };
export const getTemplates = () => state;

export const WORLD_SETTINGS = [["fantasy", "Fantasy"], ["high_fantasy", "High / epic fantasy"], ["scifi", "Sci-fi / space opera"], ["cyberpunk", "Cyberpunk"],
  ["steampunk", "Steampunk"], ["postapoc", "Post-apocalyptic"], ["modern", "Modern / real world"], ["historical", "Historical"], ["mythology", "Mythology"],
  ["superhero", "Superhero"], ["horror", "Horror"], ["romance", "Romance"]];
const FAMILY = { high_fantasy: ["fantasy"], mythology: ["fantasy"], steampunk: ["fantasy", "historical"], cyberpunk: ["scifi", "modern"],
  postapoc: ["modern"], superhero: ["modern"], horror: ["modern"], historical: ["modern"] };
export const settingLabel = (k) => (k.startsWith("custom:") ? k.slice(7) : WORLD_SETTINGS.find(([x]) => x === k)?.[1] || k);
const expand = (ss) => new Set(ss.flatMap((s) => [s, ...(FAMILY[s] || [])]));
const LEVELS = ["planet", "continent", "country", "region", "city"];
const TYPE_SYN = { world: "planet", moon: "planet", kingdom: "country", nation: "country", empire: "country", realm: "country", republic: "country",
  province: "region", state: "region", county: "region", duchy: "region", town: "city", village: "city", capital: "city", settlement: "city", metropolis: "city" };
const SYN = { participants: ["parties", "combatants", "belligerents", "involved"], climate: ["weather"], homeland: ["homeworld", "home"],
  birthdate: ["bornon", "dob", "dateofbirth", "birthday", "birthyear"], eyecolor: ["eyes", "eye"], haircolor: ["hair"], height: ["tall", "stature"], birthplace: ["bornin", "placeofbirth", "hometown"], race: ["species", "ancestry"], occupation: ["role", "job", "profession", "title"], affiliation: ["allegiance", "faction", "member"],
  leader: ["ruler", "head", "commander"], headquarters: ["base", "seat", "capital"], ruler: ["leader", "government", "monarch"],
  appearance: ["description", "looks"], type: ["kind"], outcome: ["result", "aftermath"], date: ["year", "when"],
  owner: ["wielder", "bearer"], creator: ["maker", "forged", "crafted"], speakers: ["spokenby"], source: ["powersource"] };

export const nk = (s) => String(s || "").toLowerCase().replace(/colour/g, "color").replace(/[^a-z0-9]/g, "");
const stem = (k) => (k.length > 4 && k.endsWith("s") ? k.slice(0, -1) : k);

export function keyMatches(attrKey, f) {
  const a = stem(nk(attrKey));
  const c = new Set([stem(nk(f.key)), stem(nk(f.label))]);
  [...c].forEach((x) => [...(SYN[x] || []), ...(SYN[`${x}s`] || [])].forEach((y) => c.add(stem(y))));
  return [...c].some((x) => x && (a === x || (x.length >= 4 && a.length >= 4 && (a.includes(x) || x.includes(a)))));
}

export function applicableFields(category, attributes = {}) {
  const { templates, settings } = state;
  const active = expand(settings);
  let out = (templates[category] || []).filter((f) => !f.settings?.length || f.settings.some((s) => active.has(s)));
  const typeVal = Object.entries(attributes).find(([k]) => nk(k) === "type")?.[1];
  let t = nk(typeVal);
  if (t) {
    t = TYPE_SYN[t] || t;
    if (LEVELS.includes(t)) { const skip = LEVELS.slice(LEVELS.indexOf(t)); out = out.filter((f) => !skip.includes(nk(f.key))); }
    out = out.filter((f) => nk(f.key) !== t);
  }
  return out;
}

export const missingFields = (category, attributes = {}) =>
  applicableFields(category, attributes).filter((f) => nk(f.key) !== "aliases" && !Object.entries(attributes).some(([k, v]) => String(v).trim() && keyMatches(k, f)));
